export default __webpack_public_path__ + "static/media/receive-photos.2e4bb14b.webp";